// extracted by mini-css-extract-plugin
export default {"content":"DataCard_content__AzttG","headerText":"DataCard_headerText__5jrAh","text":"DataCard_text__0t5m1"};